import React from "react";
import TablaSolicitudBeneficio from "js/components/TablaSolicitudBeneficio";

function SolicitudBeneficio(props) {
  return <TablaSolicitudBeneficio />;
}

export default SolicitudBeneficio;
